import React, { Fragment, lazy, Suspense } from 'react'
import { Route } from 'react-router-dom'
const Home = lazy(() => import('../pages/home/Home'));

export default () => (
  <Suspense fallback={() => <span>Loading</span>}>
    <Route exact path="/" component={Home} />
    <Route exact path="/process/:process" component={Home} />
    <Route exact path="/auth/autenticacao/confirmation/registration/:token" render={(renderProps) => {
      return <Home {...renderProps} redirect={true} stage="createPassword" />;
    }} />
    <Route exact path="/auth/autenticacao/api/confirmation/registration/:token" render={(renderProps) => {
      return <Home {...renderProps} redirect={true} stage="createApiPassword" />;
    }} />
    <Route exact path="/auth/autenticacao/colab/confirmation/registration/:token" render={(renderProps) => {
      return <Home {...renderProps} redirect={true} stage="createColabPassword" />;
    }} />
    <Route exact path="/auth/:token/:email" render={(renderProps) => {
      return <Home {...renderProps} redirect={true} stage="resetPassword" />;
    }} />
    <Route exact path="/auth/colab/:token/:email" render={(renderProps) => {
      return <Home {...renderProps} redirect={true} stage="resetPasswordColab" />;
    }} />
  </Suspense>
);